var React = require('react');

function AudioSoundOffIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#29C2DF;}\n"),React.createElement("rect",{"x":"2","y":"8","className":"st0","width":"5","height":"1","key":1}),React.createElement("rect",{"x":"9","y":"8","className":"st0","width":"5","height":"1","key":2}),React.createElement("rect",{"x":"16","y":"8","className":"st0","width":"5","height":"1","key":3})]);
}

AudioSoundOffIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 23 11","style":{"enableBackground":"new 0 0 23 11"},"xmlSpace":"preserve"};

module.exports = AudioSoundOffIcon;

AudioSoundOffIcon.default = AudioSoundOffIcon;
